import { serverAxios } from '@/shared/api';
import {
  ArticleListApiResponse,
  ArticleListQueryParams,
  ArticleResponseItem,
} from '@/shared/types';

export const articleListApi = async ({
  category,
  ordering,
  page,
}: ArticleListQueryParams) => {
  return await serverAxios.get<ArticleListApiResponse>('/yozmit/news/', {
    params: {
      category,
      ordering,
      page,
    },
  });
};

export const featuredArticleListApi = async () => {
  return await serverAxios.get<ArticleListApiResponse>(
    '/yozmit/news-featured/'
  );
};

export const popularArticleListApi = async ({
  page,
}: Pick<ArticleListQueryParams, 'page'>) => {
  return await serverAxios.get<ArticleListApiResponse>(
    '/yozmit/news-main-popular/',
    {
      params: { page },
    }
  );
};

export const searchArticleListApi = async ({
  query,
  page,
}: Pick<ArticleListQueryParams, 'query' | 'page'>) => {
  return await serverAxios.get<ArticleListApiResponse>('/yozmit/news/search/', {
    params: { q: query, page },
  });
};

export interface RelatedScrapArticleListParams {
  id: string;
}

export const relatedScrapArticleListApi = async ({
  id,
}: RelatedScrapArticleListParams) => {
  return await serverAxios.get<ArticleListApiResponse>(
    `/yozmit/news/${id}/related-scraps/`
  );
};

interface LandingArticleListResponse {
  id: number;
  news_data: ArticleResponseItem;
  view_count_diff?: number;
  rank: number;
  rank_diff: number;
}

export const landingTrendingArticleListApi = async () => {
  return await serverAxios.get<LandingArticleListResponse[]>(
    '/yozmit/news-weekly-top-4/'
  );
};

export const landingMostScrappedArticleListApi = async () => {
  return await serverAxios.get<LandingArticleListResponse[]>(
    '/yozmit/news-weekly-top-6-scraped/'
  );
};

export interface RecommendationArticleParams {
  year: number;
  role: string;
}

export const landingTargetRecommendationArticleListApi = async ({
  year,
  role,
}: RecommendationArticleParams) => {
  return await serverAxios.get<ArticleResponseItem[]>(
    '/yozmit/news-statistics-top-4/',
    {
      params: {
        career_year: year,
        role,
      },
    }
  );
};

export interface CareerRoleApiResponse {
  user_role: string;
  user_total_career_year: number;
  count: number;
  user_role_kor: string;
}

export const trendingRandomCareerRoleApi = async ({
  year,
  role,
}: RecommendationArticleParams) => {
  return await serverAxios.get<CareerRoleApiResponse>(
    '/yozmit/news-trending-career-random/',
    {
      params: {
        career_year: year,
        role,
      },
    }
  );
};
